export default [
    {
        name: 'Relatórios Convênio',
        url: '/gescon/relatoriosconvenios',
        icon: 'fa fa-file-text-o',
        regras: 'CONV-REL-00',
        badge: {
            variant: 'primary',
            text: 'GESCON'
        }
    }
]
